import React from 'react';
import { Tabs } from '@facet-wealth/design';
import {
  useNextUpReviewContext,
} from 'Views/Page/Content/Modal/Layouts/FacetPlanProposalNextUpReview/Layout/Components/NextUpContext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import TabContent from './TabContent';

const useStyles = buildUseStyles('DialogContent', ((theme) => ({
  root: {},
  tabHeader: {
    position: 'sticky',
    top: theme.spacing(-1), // Don't follow this pattern. Necessary for this layout and sticky tabs
    marginTop: theme.spacing(-1), // Don't follow this pattern. Necessary for this layout and sticky tabs
    zIndex: 100,
  },
}
)));

const DialogContent = () => {
  const { nextUpReviewResource: resource } = useNextUpReviewContext();
  const classes = useStyles();

  const firstTabName = resource.attr('proposalScenarioNextUpGroups').resources().head()?.attr('title');
  const [tabName, setTabName] = React.useState(firstTabName);

  // TODO: Something better to compare on
  const tabResource = resource.attr('proposalScenarioNextUpGroups').resources().list().find((tab) => {
    return tab.attr('title') === tabName;
  });

  return (
    <>
      <Paper elevation={0} className={classes.tabHeader}>
        <Tabs.Horizontal
          onChange={(_event, tabValue) => {
            setTabName(tabValue);
          }}
          value={tabName}
          options={resource.attr('proposalScenarioNextUpGroups').resources().list().map((tab) => {
            return ({
              value: tab.attr('title'),
              label: tab.attr('title'),
            });
          })}
        />
      </Paper>
      <TabContent resource={tabResource} />
    </>
  );
};

export default DialogContent;
